export function initMessageDefinitions(collection) {
    Object.entries(collection).forEach(([key, value]) => {
        if (value.name != "") {
            throw new Error(`Message definition "${key}" already has this name: ${String(value)}`);
        }
        value.name = key;
    });
    return collection;
}
//# sourceMappingURL=initMessageDefinitions.js.map